import { Box, Switch, TextField, Typography, useTheme } from '@mui/material';
import React, { ChangeEvent, Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  contactEmail: string;
  imprintLink: string;
  privacyPolicyLink: string;
  logoLink: string;
  contactForm?: boolean;
  onChange?: Dispatch<
    SetStateAction<{
      privacyPolicyLink: string;
      contactEmail: string;
      imprintLink: string;
      logoLink: string;
      contactForm?: boolean;
    }>
  >;
}

const SurveyContactData: FC<Props> = ({
  privacyPolicyLink,
  contactEmail,
  imprintLink,
  contactForm,
  onChange,
  logoLink,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [data, setData] = useState({
    privacyPolicyLink: privacyPolicyLink,
    contactEmail: contactEmail,
    imprintLink: imprintLink,
    contactForm: contactForm,
    logoLink: logoLink,
  });

  useEffect(() => {
    if (onChange) {
      onChange(data);
    }
  }, [data, onChange]);

  return (
    <Box
      sx={{
        display: 'flex',
        mt: theme.spacing(1),
        flexDirection: 'column',
      }}
    >
      <TextField
        label={t('imprint_link_label')}
        size="small"
        value={data.imprintLink}
        placeholder={t('imprint_link_placeholder')}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          setData((prevState) => ({
            ...prevState,
            imprintLink: event.target.value,
          }));
        }}
        sx={{ mt: theme.spacing(1) }}
        fullWidth
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: theme.spacing(1),
          justifyContent: 'space-between',
        }}
      >
        <TextField
          label={t('privacy_policy_link_label')}
          size="small"
          value={data.privacyPolicyLink}
          placeholder={t('privacy_policy_link_placeholder')}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setData((prevState) => ({
              ...prevState,
              privacyPolicyLink: event.target.value,
            }));
          }}
          sx={{ mt: theme.spacing(1) }}
          fullWidth
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: theme.spacing(1),
          justifyContent: 'space-between',
        }}
      >
        <TextField
          label={t('logo_link_label')}
          size="small"
          value={data.logoLink ?? ''}
          placeholder={t('logo_link_placeholder')}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setData((prevState) => ({
              ...prevState,
              logoLink: event.target.value,
            }));
          }}
          sx={{ mt: theme.spacing(1) }}
          fullWidth
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: theme.spacing(1),
          justifyContent: 'space-between',
        }}
      >
        <TextField
          label={'Email'}
          size="small"
          value={data.contactEmail}
          placeholder={'z.B jondoe@google.com'}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setData((prevState) => ({
              ...prevState,
              contactEmail: event.target.value,
            }));
          }}
          sx={{ mt: theme.spacing(1) }}
          fullWidth
        />
      </Box>
    </Box>
  );
};

export default SurveyContactData;
